<template>
  <div class="home mt-3">
    <filtros-box
      entidad="Keyword"
      :show-descargar="true"
      @descargar="getKeywordsExcel"
      @modelActivo="keyword_activo = $event"
      @model="keyword_sel = $event"
      @muestraModal="showEdit({}, 'add')"
      @buscar="keywordsBuscar()"
    >
    </filtros-box>

    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>


        
    <data-table
      v-if="keywordsBusqueda && keywordsBusqueda.data.length"
      :columns="columns"
      :data="keywordsBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_keyword"
      @sort="orderByfield"
    >
      <template #actions="{ item }">
        <table-actions
          :item="item"
          @edit="showEdit(item, 'edit')"
          @toggle="showEdit(item, 'toggle')"
        />
      </template>
    </data-table>
    <Paginador
      v-if="keywordsBusqueda && keywordsBusqueda.pages"
      :pages="keywordsBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <empty-state
      :show="Boolean(post && keywordsBusqueda && keywordsBusqueda.data && !keywordsBusqueda.data.length)"
      message="No se encontraron keywords que coincidan con la búsqueda."
    />
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-dialog-scrollable"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Keyword</span>
                    <span v-if="editData.activo == 0"> Reactivar Keyword</span>
                  </h5>
                  <h5 v-if="operation == 'edit'" class="modal-title">
                    Editar Keyword {{ editData.id_keyword }}
                  </h5>
                  <h5 v-if="operation == 'add'" class="modal-title">
                    Nuevo Keyword
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form v-if="operation == 'edit' || operation == 'add'">
                    <div
                      v-if="operation != 'add'"
                      class="form-group"
                      style="display: none"
                    >
                      <label>Id Keyword</label>
                      <b class="form-control">{{ editData.id_keyword }}</b>
                    </div>
                    <div class="form-group">
                      <label>Keyword</label>
                      <b class="form-control" v-if="operation == 'toggle'">{{
                        editData.keyword
                      }}</b>
                      <input
                        class="form-control"
                        v-if="operation === 'edit' || operation === 'add'"
                        type="text"
                        placeholder="Ej: clubjuegos"
                        v-model="editData.keyword"
                        maxlength="50"
                        @input="(e) => (editData.keyword = e.target.value.toLowerCase().slice(0, 50))"
                      />
                      <small class="form-text text-muted">Palabra clave en minúsculas sin espacios ni caracteres especiales (máx. 50 caracteres).</small>
                    </div>
                    <div v-if="errors" class="alert alert-danger" role="alert">
                      {{ errors }}
                       <ul>
                        <li v-for="errordetalle of errorsD" v-bind:key="errordetalle"
>
                          {{errordetalle}}
                        </li>
                      </ul>
                    </div>
                  </form>

                  <p v-if="operation == 'toggle'">
                    Esta seguto de realizár esta acción?
                  </p>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'edit'"
                    @click="editKeyword"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'add'"
                    @click="agregarKeyword"
                    class="btn btn-primary"
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import filtrosBox from "./utiles/filtrosBox.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";

export default {
  name: "Keywords",
  mixins: [tableSortMixin],
  data() {
    return {
      columns: [
        { label: "Id", field: "id_keyword", width: "80" },
        { label: "Keyword", field: "keyword" },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      success: null,
      error: null,
      id_integrador_sel: localStorage.getItem("integrador"),
      keyword_activo: "",
      keyword_sel: "",
      keywordsBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      errorsD: [],
      pages: null,
    };
  },
  components: {
    DataTable,
    Paginador,
    filtrosBox,
    TableActions,
    EmptyState,
  },
  created() {
    this.getKeywordsBusqueda();
  },
  computed: { ...mapGetters("auth", ["user"]) },
  methods: {
    keywordsBuscar: function () {
      this.changePage(1);
    },
    changePage: function (page) {
      this.page = page;
      this.getKeywordsBusqueda(false);
    },
    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getKeywordsBusqueda(false);
    },
    getKeywordsBusqueda: function (hideResult = true) {
      if (hideResult) this.keywordsBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/busqueda", {
          page: this.page,
          id_integrador: this.id_integrador_sel,
          keyword: this.keyword_sel,
          activo: this.keyword_activo,
          order_by: {
            field: this.orderByField,
            order: this.orderByDirection,
          },
        })
        .then((response) => {
          this.keywordsBusqueda = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las keywords",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

  getKeywordsExcel: function () {
    startAsyncExport("keyword", {
      id_integrador: this.id_integrador_sel,
      order_by: {
        field: this.orderByField,
        order: this.orderByDirection,
      },
    }, "Keywords");
  },
    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Keywords actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getKeywordsBusqueda();
        });
    },
    editKeyword: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;

          } else {
            Swal.fire({
              title: "Bien!",
              text: "Keywords actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
            this.errorsD=e.response.data.errors.keyword;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getKeywordsBusqueda();
        });
    },
    showEdit: function (item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      this.showModal = true;
      this.operation = operation;
    },
    agregarKeyword: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.id_integrador = parseInt(
        localStorage.getItem("integrador")
      );
      axios
        .post(process.env.VUE_APP_API_URL + "keyword/new", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Keywords creada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
            this.errorsD=e.response.data.errors.keyword;

          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getKeywordsBusqueda();
        });
    },
    closeModal() {
      this.showModal = false;
      this.operation = null;
    },
  },
};
</script>
<style scoped></style>